import propTypes from 'prop-types';
import { useContext } from 'react';

import Sidebar from './Sidebar';

import AppContext from 'context/app.context';
import clsx from 'libs/clsx';

function DashboardContainer({
  activeSidebarItem,
  showProfileOnSidebar,
  children,
}) {
  const [{ isSidebarOpen }] = useContext(AppContext);

  return (
    <>
      <Sidebar
        activeItem={activeSidebarItem}
        showProfileCard={showProfileOnSidebar}
      />

      <div
        className={clsx(
          'min-h-screen mx-4 pt-6 md:pt-0 transition-all duration-300 ease-in-out',
          isSidebarOpen ? 'md:2xl:pl-80 md:xl:pl-80 md:pl-72' : 'pl-0'
        )}
      >
        {children}
      </div>
    </>
  );
}

DashboardContainer.defaultProps = {
  showProfileOnSidebar: false,
};

DashboardContainer.propTypes = {
  activeSidebarItem: propTypes.string.isRequired,
  showProfileOnSidebar: propTypes.bool,
  children: propTypes.node.isRequired,
};

export default DashboardContainer;
